<app-header></app-header>
<main class="main-content">
  <!------main-content------>
  <!-----------page_title--------------->
  <section class="page_title pdt_80 pdb_40">
    <div class="container">
      <div class="row">
        <!---------row----------->
        <div class="col-lg-12 col-md-12 text-center">
          <!---------col----------->
          <div class="content_box">
            <h6>Search Nearest Center</h6>
            <h1>COVID-19 Test Center</h1>
            <ul class="bread_crumb text-center">
              <li class="bread_crumb-item"><a href="#">Home</a></li>
              <li class="bread_crumb-item active">Test Center</li>
            </ul>
          </div>
          <!---------col-end---------->
        </div>
        <!----------row-end---------->
      </div>
    </div>
  </section>
  <!-----------page_title-end-------------->

  <section class="type_two pdt_50 pdb_50">
    <form
      [formGroup]="searchForm"
      (ngSubmit)="onSubmitSearch(searchForm.value)"
    >
      <div class="container mb-4">
        <div class="filter-bg">
          <div class="row">
            <!-- <div class="col-lg-2"><h5 class="filter-bg">Filter by:</h5></div> -->

            <div class="col-lg-4">
              <input
                type="text"
                name="center_provinces"
                formControlName="center_provinces"
                placeholder="Provinces"
                class="filter-provi"
              />
            </div>

            <div class="col-lg-4 mt_less_320_15">
              <input
                type="text"
                name="center_name"
                formControlName="center_name"
                placeholder="Name"
                class="filter-center"
              />
            </div>

            <div class="col-lg-2 col-sm-6 mt_less_320_15 mb_less_320_15">
              <button type="submit" class="filter-btn">
                <i class="fas fa-search"></i> Search
              </button>
            </div>

            <div class="col-lg-2 col-sm-6 mt_less_320_15 mb_less_320_15">
              <!-- <input type="button" value="Clear" class="filter-btn" (click)="clearSearch()">  -->
              <button type="button" class="filter-btn" (click)="clearSearch()">
                <i class="fas fa-redo"></i> Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="container">
      <div class="row">
        <!---------row----------->
        <div
          class="col-lg-6 col-md-6 col-sm-12"
          *ngFor="
            let center of collectionCenters | paginate: config;
            index as i
          "
        >
          <!---------symptoms_box----------->
          <div
            class="symptoms_box type_two wow fadeIn animated"
            data-wow-delay="100ms"
            data-wow-duration="1500ms"
            style="
              display: block;
              visibility: visible;
              animation-duration: 1500ms;
              animation-delay: 100ms;
              animation-name: fadeIn;
            "
          >
            <!-- <div class="image_box">
                     <img src="assets/image/center/center-1.png" class="img-fluid">
                  </div> -->
            <div class="content_box">
              <h2 class="center-name">{{ center.name }}</h2>
              <div class="center-add">
                <strong><i class="fas fa-map-marker-alt"></i></strong> &nbsp;
                &nbsp; {{ center.address }}<br />
                <strong><i class="fas fa-envelope-open-text"></i></strong>
                &nbsp; &nbsp; {{ center.email }}<br />
                <strong><i class="fas fa-phone-square-alt"></i></strong> &nbsp;
                &nbsp; {{ center.phone }} <br />
                <div class="timing-box">
                  <strong><i class="fas fa-user-clock"></i></strong>

                  <div class="center-timing">
                    <div
                      class="test-sm"
                      *ngFor="let item of center?.working_days | keyvalue"
                    >
                    <span *ngIf="!isNumber(item.key)">
                     {{ item.key | titlecase }}:
                     {{
                       "2020-12-12T" + item.value?.opening_time
                         | date: "h:mm a"
                     }}
                     -
                     {{
                       "2020-12-12T" + item.value?.closing
                         | date: "h:mm a" + ", &nbsp; "
                     }}
                    </span>
                      
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
          <!---------symptoms_box-end---------->
        </div>
      </div>
      <div class="table-footer">
        <div
          id="page_info"
          class="mt-3 record-show-text-bottom"
          *ngIf="collectionCenters"
        >
          Showing
          {{ (config.currentPage - 1) * config.itemsPerPage + 1 }} -
          {{ config.currentPage * config.itemsPerPage }} of
          {{ config.totalItems }} entries
        </div>

        <div class="pagination paging-pull-right" *ngIf="collectionCenters">
          <pagination-controls
            (pageChange)="pageChange($event)"
            class="my-pagination mt-2 pagination-server"
          ></pagination-controls>
        </div>
      </div>
      <!-- <div class="row">
            <div class="col-lg-12 text-center">
               <a href="javascript:void(0);" class="theme_btn tp_two logo-button-website"> Load More</a>
            </div>
         </div> -->
    </div>
  </section>

  <app-footer></app-footer>
</main>

<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>
